// Laravel JavaScript Bootstrapping
require('./bootstrap');

// jQuery
window.$ = window.jQuery = require('jquery');

// == jQuery Plugins ==

// Select2
require('./plugins/selectTwo');

// Tags input
require('./plugins/jQueryTagsInput');

// == End jQuery Plugins ==

// Bootstrap v3.3.4
require('./vendor/bootstrap.min.js');

// date-fns - Date formatting library
import { format } from 'date-fns';
import { add } from 'date-fns';
import { parse } from 'date-fns';

// Vue
import Vue from 'vue';

// Toast notifications
import Toasted from 'vue-toasted';

// Composition api plugin
import VueCompositionAPI from '@vue/composition-api';
Vue.use(VueCompositionAPI);

// Vue Portal Plugin
import PortalVue from 'portal-vue';
Vue.use(PortalVue);

// Vue floating ui
import FloatingVue from 'floating-vue'
Vue.use(FloatingVue)

// Create an event bus
window.EventBus = new Vue();

// Component Registrations
import TheNavbar from './components/TheNavbar.vue';
import AdminSidebar from './components/AdminSidebar.vue';
import SidebarDropdown from './components/SidebarDropdown.vue';
// import SelectChosen from './components/SelectChosen.vue';
import DataTable from './components/DataTable.vue';
import DataTableColumn from './components/DataTableColumn.vue';
import FlashMessage from './components/FlashMessage.vue';
import BaseTab from './components/BaseTab.vue';
import TabGroup from './components/TabGroup.vue';
import TabButton from './components/TabButton.vue';
import TheModal from './components/TheModal.vue';
import ModalContent from './components/ModalContent.vue';
import ModalButton from './components/ModalButton.vue';
import BaseForm from './components/BaseForm.vue';
import FormControl from './components/FormControl.vue';
import SearchList from './components/SearchList.vue';
import AcceptHosted from './components/AcceptHosted.vue';
// BaseTray shouldn't really be an async component because it's important for the initial page load, but it was giving me layout calculation problems
// import BaseTray from './components/BaseTray.vue';
import ShowMore from './components/ShowMore.vue';
// import SearchSelect from './components/SearchSelect.vue';
import Portrait from './components/Portrait.vue';
import PhotoUploader from './components/PhotoUploader.vue';
import SubmitButton from './components/SubmitButton.vue';
import InputTags from './components/InputTags.vue';
import TimeoutCounter from './components/TimeoutCounter.vue';
import DateRange from './components/DateRange.vue';
import ContactCards from './components/ContactCards.vue';
import EditParticipant from './components/EditParticipant.vue';
import ResidentStates from './components/ResidentStates.vue';
import Chat from './components/Chat.vue';
import ChatIndex from './components/ChatIndex.vue';
import MultipleChats from './components/MultipleChats.vue';
import ChatAlert from './components/ChatAlert.vue';
import FirstLastClass from './components/FirstLastClass.vue';
import MembershipForm from './components/MembershipForm.vue';
import CECredits from './components/CECredits.vue';



Vue.component('the-navbar', TheNavbar);
Vue.component('admin-sidebar', AdminSidebar);
Vue.component('sidebar-dropdown', SidebarDropdown);
Vue.component('select-chosen', () => import(/* webpackPrefetch: true */ './components/SelectChosen.vue'));
Vue.component('data-table', DataTable);
Vue.component('data-table-column', DataTableColumn);
Vue.component('flash-message', FlashMessage);
Vue.component('tab-group', TabGroup);
Vue.component('base-tab', BaseTab);
Vue.component('tab-button', TabButton);
Vue.component('the-modal', TheModal);
Vue.component('modal-content', ModalContent);
Vue.component('modal-button', ModalButton);
Vue.component('base-form', BaseForm);
Vue.component('form-control', FormControl);
Vue.component('base-loader', () => import(/* webpackPrefetch: true */ './components/BaseLoader.vue'));
Vue.component('to-top', () => import(/* webpackPrefetch: true */ './components/ToTop.vue'));
Vue.component('search-list', SearchList);
Vue.component('accept-hosted', AcceptHosted);
Vue.component('event-carousel', () => import('./components/EventCarousel.vue'));
Vue.component('multi-tier-select', () => import(/* webpackPrefetch: true */ './components/MultiTierSelect.vue'));
Vue.component('base-tray', () => import(/* webpackPrefetch: true */ './components/BaseTray.vue'));
Vue.component('data-fetch', () => import(/* webpackPrefetch: true */ './components/DataFetch.vue'));
Vue.component('text-expand', () => import(/* webpackPrefetch: true */ './components/TextExpand.vue'));
Vue.component('show-more', ShowMore);
Vue.component('browser-select', () => import(/* webpackPrefetch: true */ './components/BrowserSelect.vue'));
Vue.component('phone-block', () => import(/* webpackPrefetch: true */ './components/PhoneBlock.vue'));
Vue.component('search-select', () => import(/* webpackPrefetch: true */ './components/SearchSelect.vue'));
Vue.component('participant-search-select', () => import(/* webpackPrefetch: true */ './components/ParticipantSearchSelect.vue'));
Vue.component('company-search-select', () => import(/* webpackPrefetch: true */ './components/CompanySearchSelect.vue'));
Vue.component('cancellation-policy', () => import('./components/CancellationPolicy.vue'));
Vue.component('create-transaction', () => import('./components/CreateTransaction.vue'));
Vue.component('create-online-transaction', () => import('./components/CreateOnlineTransaction.vue'));
Vue.component('create-refund', () => import('./components/CreateRefund.vue'));
Vue.component('merge-selector', () => import('./components/MergeSelector.vue'));
Vue.component('portrait', Portrait);
Vue.component('photo-uploader', PhotoUploader);
Vue.component('submit-button', SubmitButton);
Vue.component('currency-mask', () => import(/* webpackPrefetch: true */ './components/CurrencyMask.vue'));
Vue.component('input-tags', InputTags);
Vue.component('file-dropzone', () => import(/* webpackPrefetch: true */ './components/FileDropzone.vue'));
Vue.component('cropper-field', () => import(/* webpackPrefetch: true */ './components/CropperField.vue'));
Vue.component('repeater-block', () => import('./components/RepeaterBlock.vue'));
Vue.component('timeout-counter', TimeoutCounter);
Vue.component('date-range', DateRange);
Vue.component('vue-editor', () => import('./components/VueEditor.vue'));
Vue.component('virtual-scroller', () => import('./components/VirtualScroller.vue'));
Vue.component('recycle-scroller', async () => {
    let {RecycleScroller} = await import('vue-virtual-scroller');
    return RecycleScroller;
});
Vue.component('rich-text-to-state', () => import('./components/RichTextToState.vue'));
Vue.component('copy-to-clipboard', () => import('./components/CopyToClipboard.vue')); 
Vue.component('vue-email-editor', () => import('./components/VueEmailEditor.vue'));
Vue.component('file-manager', () => import(/* webpackPrefetch: true */ './components/FileManager.vue'));
Vue.component('password', () => import(/* webpackPrefetch: true */ 'vue-password-strength-meter')); 
Vue.component('websocket-test', () => import('./components/WebsocketTest.vue')); 
Vue.component('contact-cards', () => import('./components/ContactCards.vue')); 
Vue.component('edit-participant', () => import('./components/EditParticipant.vue')); 
Vue.component('resident-states', () => import('./components/ResidentStates.vue')); 
Vue.component('chat', () => import('./components/Chat.vue')); 
Vue.component('chat-index', () => import('./components/ChatIndex.vue')); 
Vue.component('multiple-chats', () => import('./components/MultipleChats.vue')); 
Vue.component('chat-alert', () => import('./components/ChatAlert.vue')); 
Vue.component('first-last-class', () => import('./components/FirstLastClass.vue')); 
Vue.component('membership-form', () => import('./components/MembershipForm.vue')); 
Vue.component('c-e-credits', () => import('./components/CECredits.vue')); 


// Import mixins
// These are methods that are used in more than one Vue component
import capitalize from './mixins/capitalize';
import formatCurrency from './mixins/formatCurrency';

// Base Vue instance
new Vue({
    el: '#app',
    
    mixins: [capitalize, formatCurrency],

    data() {
        return {
            EventBus: EventBus,
        }
    },

    mounted() {
        this.$el.classList.add('reveal-after-load');

        this.$nextTick(() => {
            // Vue Toasted has to be initialized after page load for some reason
            Vue.use(Toasted, { 
                position: 'top-center',
                iconPack: 'custom-class'
            });

            // Initialize Bootstrap tooltips
            $('[data-toggle="tooltip"]').tooltip();
        });
    },

    methods: {
        // makes console.log available from the template scope
        log(...values){
            console.log(...values);
        },

        redirect(href, newTab = false) {
            window.open(href, newTab ? '_blank' : '_self');
        },

        refresh(params = {}) {
            let currentParams = new URLSearchParams(window.location.search);
            
            Object.entries(params).forEach(([key, value]) => {
                currentParams.set(key, value);
            });
            
            window.location.search = currentParams.toString();

            // window.location.reload();
        },

        dateFormat(date, formatting) {
            return format(date, formatting);
        },

        addMonths(startDate, numMonths, style = 'double'){
            if(startDate && numMonths > 2){
                let date = new Date(startDate + 'T06:00:00'); ///year, month-1, day, 10, 10, 10);
                let d = add(date, {months: numMonths, days: -1});
           
                if(style != 'double'){
                    return format(d, 'M/d/y');
                }
                return format(d, 'MM/dd/y');
            }
        },

        getBase64(event, state) {
            var reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = function () {
                console.log(reader.result);
                state.base64 = reader.result;
                
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };

        },

        notify(message, options = {}) {
            let defaults = {
                duration: 3000
            };
            
            options = Object.assign(defaults, options);

            this.$toasted.show(message, options);
        }
    }
});